// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForecastSchema } from './v1/forecastSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const listTasksPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const listTasksQueryParamsSchema = z.object({
  since: z.optional(z.string().date().describe("Filter tasks from this date (inclusive)")),
  upto: z.optional(z.string().date().describe("Filter tasks up to this date (inclusive)")),
  completed: z.optional(z.enum(["true", "false"]).describe("Filter by completion status")),
  user_ids: z.optional(z.coerce.string().describe("Comma-separated list of user IDs to filter by")),
  project_ids: z.optional(z.coerce.string().describe("Comma-separated list of project IDs, or \"active\"/\"archived\" to filter by project status")),
  forecast_ids: z.optional(z.coerce.string().describe("Comma-separated list of task IDs to filter by")),
  sort: z.optional(z.enum(["updated_at", "created_at", "from", "to"]).describe("Field to sort by (default: updated_at)")),
  order: z.optional(z.enum(["asc", "desc"]).describe("Sort order (default: desc)")),
  per_page: z.optional(z.number().int().min(1).max(5000).describe("Number of results per page (max 5000)")),
  page: z.optional(z.number().int().min(1).describe("Page number for pagination")),
}).optional();

export const listTasksHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Tasks list
 */
export const listTasks200Schema = z.array(z.lazy(() => v1ForecastSchema));

/**
 * @description Unauthorized
 */
export const listTasks401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const listTasksQueryResponseSchema = z.lazy(() => listTasks200Schema);
